import React from "react";
import { Row, Col } from "react-bootstrap";
import IOText from "../../ReUableComponents/ImageOntext";
import PBanner from "../../Assessts/Images/Gallary/Publications/PBanner.png";

import P1 from "../../Assessts/Images/Gallary/Publications/P1.png";
import P2 from "../../Assessts/Images/Gallary/Publications/P2.png";
import P3 from "../../Assessts/Images/Gallary/Publications/P3.png";
import B1 from "../../Assessts/Images/Gallary/Publications/B1.png";
const Publications = () => {
     const Publications = [
        { img: P1,ITittle:"Vidya Setu August Newsletter" },
        { img: P2,ITittle:"Vidya Setu September Newsletter" },
        { img: P3,ITittle:"Vidya Setu October Newsletter" },
    ];
    const Brouchers =[ { img: B1,ITittle:"NSF Scholarship Program Flyer" }, ];

    const Pdata = [
        { Data: Publications, Tittle: "Publications", SubTittle: "Newsletters" },
        { Data: Brouchers, SubTittle: "Brouchers" },
    ];
    return (
        <div className="m-4">
<div className="Single_Banner mt-2 mb-4">
                <IOText Image={PBanner} Alt="EMpower" Text={<div className="Text-MainDiv w-100" >
                    <div >
                        Official <span style={{ color: "#F7D670" }}>Publications Showcasing Scholarship Programs</span> and Academic Impact.</div>

                </div>} />
            </div>
           <div className="SEngagement">
                          {Pdata.map((item) => (
                              <>
                                  <div className="Web-MainHeading"> {item.Tittle}  </div>
                                  <div className="Web-SubHeading"> {item.SubTittle}  </div>
                                  <div className="container-fluid  mb-3 p-2">
                                      <Row className="dflex  ">
                                          {item.Data.map((item) => (
                                              <Col className="dflex  flexd-column alignitems mt-3" >
                                                  <img src={item.img} alt="{`${item}`}" />
                                                  <p className="mt-1 " style={{color:"#347462",fontWeight:"700"}}>{item.ITittle}</p>
                                              </Col>
                                          ))}
                                      </Row>
                                  </div>
                              </>
                          ))}
                      </div>
        </div>
    )
}
export default Publications;